module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9n2n5r-99732c2cb04a2fa45fbdeefd70d6c5ac.svg";